import { Form, InputGroup } from 'react-bootstrap'
import React, { memo } from 'react'

import PropTypes from 'prop-types'
import { XStack } from '../../index.style'
import { useField } from 'formik'

const TextField = ({ label, helperText, ...props }) => {
  const [field, meta] = useField(props.name)

  return (
    <Form.Group controlId={`validationFormik${field.name}`}>
      <XStack>
        <Form.Label as={'b'}>{label}</Form.Label>
      </XStack>
      <InputGroup hasValidation>
        <Form.Control
          type="text"
          {...field}
          {...props}
          isInvalid={meta.error && meta.touched}
          style={{ borderRadius: 16, color: 'black' }}
        />

        <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
      </InputGroup>
      <Form.Text>{helperText}</Form.Text>
    </Form.Group>
  )
}

export default memo(TextField)

TextField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  helperText: PropTypes.string,
}
